// components/AuthModal.tsx
import React, { useCallback, useEffect, useState } from "react";
import {
  Modal,
  ModalHeader,
  Nav,
  NavItem,
  NavLink,
  TabContent,
} from "reactstrap";
import LoginForm from "./LoginForm";
import SignUpForm from "./SignUpForm";
import "./AuthModal.css";
import LoginWithSocial from "./LoginWithSocial";
interface AuthModalProps {
  isOpen: boolean;
  toggle: () => void;
}

const AuthModal: React.FC<AuthModalProps> = ({ isOpen, toggle }) => {
  const [activeTab, setActiveTab] = useState<string>("signin");

  const handleTabClick = useCallback((tab: string) => {
    setActiveTab(tab);
  }, []);

  useEffect(() => {
    if (!isOpen) {
      setActiveTab("signin");
    }
  }, [isOpen]);

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="l" fade={false}>
      <ModalHeader toggle={toggle}>Unlock Roave member rates</ModalHeader>

      <Nav tabs className="justify-content-center mt-3">
        <NavItem>
          <NavLink
            className={activeTab === "signin" ? "active" : ""}
            onClick={() => handleTabClick("signin")}
          >
            Sign In
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={activeTab === "signup" ? "active" : ""}
            onClick={() => handleTabClick("signup")}
          >
            Sign Up
          </NavLink>
        </NavItem>
      </Nav>

      <TabContent activeTab={activeTab} className="p-3">
        {isOpen &&
          (activeTab === "signin" ? (
            <LoginForm
              key="auth-modal-signin"
              onSuccess={toggle}
              onSignupClick={() => handleTabClick("signup")}
            />
          ) : (
            <SignUpForm
              key="auth-modal-signup"
              onSuccess={toggle}
              onLoginClick={() => handleTabClick("signin")}
            />
          ))}
        <div className="row y-gap-20 pt-30">
          <div className="col-12">
            <div className="text-center">or sign in with</div>
          </div>
          <LoginWithSocial />
        </div>
      </TabContent>
    </Modal>
  );
};

export default AuthModal;
